import { createFeatureActionNamer } from '../../../../redux/action-name';

const getActionName = createFeatureActionNamer('life-assured-details');

export const ADD_EXTERNAL_POLICY = getActionName('ADD_EXTERNAL_POLICY');
export const UPDATE_EXTERNAL_POLICY = getActionName('UPDATE_EXTERNAL_POLICY');
export const DELETE_EXTERNAL_POLICY = getActionName('DELETE_EXTERNAL_POLICY');
